import {Navigate} from "react-router-dom"

export default function RequireEcpLicence(props) {
    let redirect = props.redirect
    let types = props.types
    if (redirect && types.includes("ecp") === false) {
        return <Navigate to="/"/>
    } else if (types.includes("ecp") === false || types === undefined) {
        return ""
    }
    return props.children
}